/**
 * Founder dev toggle — pricing-page top-up picker (preview before replacing
 * Stripe optional_items carousel).
 *
 * Primary control: Fire Station → Developer settings.
 * Deep-link only: ?dev_topup_picker=1|0 (applied once on app boot).
 */
const STORAGE_KEY = 'enferno-dev-topup-picker';
export const DEV_TOPUP_PICKER_CHANGED = 'enferno:dev-topup-picker-changed';

export function isDevTopupPickerEnabled() {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function setDevTopupPickerEnabled(enabled) {
  try {
    if (enabled) localStorage.setItem(STORAGE_KEY, '1');
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
  try {
    window.dispatchEvent(new Event(DEV_TOPUP_PICKER_CHANGED));
  } catch {
    /* ignore */
  }
}

/** Apply ?dev_topup_picker= URL flag once (call from app boot). */
export function initDevTopupPickerFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('dev_topup_picker') === '1') setDevTopupPickerEnabled(true);
    else if (params.get('dev_topup_picker') === '0') setDevTopupPickerEnabled(false);
  } catch {
    /* ignore */
  }
}
